import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createGalleryItemRequest = { item: '_item' };
var _createGalleryItemResponse = { item: '_item' };
var _createGalleryRequest = { gallery: '_gallery' };
var _createGalleryResponse = { gallery: '_gallery' };
var _deleteGalleryItemRequest = {};
var _deleteGalleryItemResponse = {};
var _gallery = {
    created: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    orderIndex: 'google.protobuf.DoubleValue',
    items: '_item',
};
var _getGalleryRequest = {};
var _getGalleryResponse = { gallery: '_gallery' };
var _getItemRequest = {};
var _getItemResponse = { item: '_item' };
var _item = {
    orderIndex: 'google.protobuf.DoubleValue',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    photoMetadata: '_photoMetadata',
    videoMetadata: '_videoMetadata',
    secondaryMedia: '_secondaryMedia',
};
var _listGalleriesRequest = { fields: 'google.protobuf.FieldMask' };
var _listGalleriesResponse = { gallery: '_gallery', galleries: '_gallery' };
var _listItemsRequest = {};
var _listItemsResponse = { items: '_item' };
var _partiallyDeleteGalleryRequest = { gallery: '_gallery' };
var _partiallyDeleteGalleryResponse = { gallery: '_gallery' };
var _partiallyUpdateGalleryRequest = { gallery: '_gallery' };
var _partiallyUpdateGalleryResponse = { gallery: '_gallery' };
var _partiallyUpdateItemRequest = { item: '_item' };
var _partiallyUpdateItemResponse = { item: '_item' };
var _photoMetadata = {
    focalPoint: '_point',
    unsharpMasking: '_unsharpMasking',
};
var _point = { x: 'DOUBLE', y: 'DOUBLE' };
var _publishGalleryRequest = {};
var _publishGalleryResponse = { gallery: '_gallery' };
var _secondaryMedia = { photoMetadata: '_photoMetadata' };
var _thumbnail = { focalPoint: '_point' };
var _unsharpMasking = {
    amount: 'google.protobuf.FloatValue',
    radius: 'google.protobuf.FloatValue',
    threshold: 'google.protobuf.FloatValue',
};
var _updateGalleryRequest = { gallery: '_gallery' };
var _updateGalleryResponse = { gallery: '_gallery' };
var _videoMetadata = { posters: '_thumbnail' };
function resolveComWixpressExposureProgalleryProtoProGalleryUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/pro-gallery-webapp/v1/galleries',
                destPath: '/v1/galleries',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/webapp-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/webapp-proxy/v1/galleries',
                destPath: '/v1/galleries',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/pro-gallery-webapp/v1/galleries',
                destPath: '/v1/galleries',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/pro-gallery-webapp/v1/galleries',
                destPath: '/v1/galleries',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/pro-gallery-webapp/v1/galleries',
                destPath: '/v1/galleries',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** List all Galleries of a Pro Gallery instance */
export function listGalleries(payload) {
    var _a = serializer(_listGalleriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGalleriesResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __listGalleries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'GET',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.ListGalleries',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGalleries.fromReq = fromReq;
    __listGalleries.__isAmbassador = true;
    return __listGalleries;
}
/** Get Gallery by id */
export function getGallery(payload) {
    var _a = serializer(_getGalleryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __getGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'GET',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.GetGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGallery.fromReq = fromReq;
    __getGallery.__isAmbassador = true;
    return __getGallery;
}
/** List items of a Gallery */
export function listGalleryItems(payload) {
    var _a = serializer(_listItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listItemsResponse, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __listGalleryItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'GET',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.ListGalleryItems',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/items',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGalleryItems.fromReq = fromReq;
    __listGalleryItems.__isAmbassador = true;
    return __listGalleryItems;
}
/** Get item by gallery id & item id */
export function getGalleryItem(payload) {
    var _a = serializer(_getItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getItemResponse, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __getGalleryItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'GET',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.GetGalleryItem',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGalleryItem.fromReq = fromReq;
    __getGalleryItem.__isAmbassador = true;
    return __getGalleryItem;
}
/** Create Gallery */
export function createGallery(payload) {
    var _a = serializer(_createGalleryRequest, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __createGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'POST',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.CreateGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGallery.fromReq = fromReq;
    __createGallery.__isAmbassador = true;
    return __createGallery;
}
/**
 * Update a gallery and its Items
 * Note: only existing items will be updated. you can't add or remove items with this endpoint
 */
export function updateGallery(payload) {
    var _a = serializer(_updateGalleryRequest, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __updateGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'PUT',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.UpdateGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{gallery.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateGallery.fromReq = fromReq;
    __updateGallery.__isAmbassador = true;
    return __updateGallery;
}
/** Update a Gallery without updating its items */
export function partiallyUpdateGallery(payload) {
    var _a = serializer(_partiallyUpdateGalleryRequest, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partiallyUpdateGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __partiallyUpdateGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'PATCH',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.PartiallyUpdateGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{gallery.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partiallyUpdateGallery.fromReq = fromReq;
    __partiallyUpdateGallery.__isAmbassador = true;
    return __partiallyUpdateGallery;
}
/** Delete items from gallery */
export function partiallyDeleteGallery(payload) {
    var _a = serializer(_partiallyDeleteGalleryRequest, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partiallyDeleteGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __partiallyDeleteGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'DELETE',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.PartiallyDeleteGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{gallery.id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partiallyDeleteGallery.fromReq = fromReq;
    __partiallyDeleteGallery.__isAmbassador = true;
    return __partiallyDeleteGallery;
}
/** Create Item in a gallery */
export function createGalleryItem(payload) {
    var _a = serializer(_createGalleryItemRequest, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGalleryItemResponse, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __createGalleryItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'POST',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.CreateGalleryItem',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGalleryItem.fromReq = fromReq;
    __createGalleryItem.__isAmbassador = true;
    return __createGalleryItem;
}
/** Partially update an item */
export function partiallyUpdateItem(payload) {
    var _a = serializer(_partiallyUpdateItemRequest, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_partiallyUpdateItemResponse, {
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __partiallyUpdateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'PATCH',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.PartiallyUpdateItem',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/items/{item.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __partiallyUpdateItem.fromReq = fromReq;
    __partiallyUpdateItem.__isAmbassador = true;
    return __partiallyUpdateItem;
}
/** Delete an item from gallery */
export function deleteGalleryItem(payload) {
    var _a = serializer(_deleteGalleryItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteGalleryItemResponse, {}).fromJSON;
    function __deleteGalleryItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'DELETE',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.DeleteGalleryItem',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteGalleryItem.fromReq = fromReq;
    __deleteGalleryItem.__isAmbassador = true;
    return __deleteGalleryItem;
}
/**
 * Publish gallery
 * The changes that been done in SAVED state will be applied in the PUBLISHED gallery
 */
export function publishGallery(payload) {
    var _a = serializer(_publishGalleryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishGalleryResponse, {
        _gallery: _gallery,
        _item: _item,
        _photoMetadata: _photoMetadata,
        _point: _point,
        _secondaryMedia: _secondaryMedia,
        _thumbnail: _thumbnail,
        _unsharpMasking: _unsharpMasking,
        _videoMetadata: _videoMetadata,
    }).fromJSON;
    function __publishGallery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.progallery.v1.gallery',
            method: 'POST',
            methodFqn: 'com.wixpress.exposure.progallery.proto.ProGallery.PublishGallery',
            url: resolveComWixpressExposureProgalleryProtoProGalleryUrl({
                protoPath: '/v1/galleries/{galleryId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishGallery.fromReq = fromReq;
    __publishGallery.__isAmbassador = true;
    return __publishGallery;
}
//# sourceMappingURL=http.impl.js.map